import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { FC } from 'react';

interface ITwCustomerMenu {
  anchor: null | HTMLElement;
  close: () => void;
  menuOptions: { label: string; action: () => void; disabled: boolean }[];
}

const TwCustomerMenu: FC<ITwCustomerMenu> = ({ anchor, close, menuOptions }) => {
  return (
    <Menu
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={(): void => close()}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className="contact-details__menu"
    >
      {menuOptions.map((option) => (
        <MenuItem key={option.label} disabled={option.disabled} onClick={option.action}>
          {option.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default TwCustomerMenu;
